import { SEO } from "gatsby-theme-core";
import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { normalizedData } from "@streamo/helper/methods";
import { Layout, HeaderOne, FooterOne } from "gatsby-theme-layout";
import {
    MyAaccountTab,
    PageHeader01,
    TabContent01,
    TabContent02,
} from "gatsby-theme-container";

const FAQPage = ({ data }) => {
    const content = normalizedData(data?.page?.content || []);
    return (
        <Layout>
            <SEO pageName="My Account" />
            <HeaderOne data={{ ...data?.header, ...data.navigation }} />
            <PageHeader01 data={content?.["page-header-section"]} />
            <MyAaccountTab>
                <TabContent01 data={content?.["account-details-section"]} />
                <TabContent02 data={content?.["payment-info-section"]} />
            </MyAaccountTab>
            <FooterOne data={{ ...data?.footer, ...data?.contact }} />
        </Layout>
    );
};

export const query = graphql`
    query FAQMyAccountPageQuery {
        header: general(section: { eq: "header-01" }) {
            ...Header01
        }
        navigation: general(section: { eq: "menu-streaming" }) {
            ...Menu01
        }
        footer: general(section: { eq: "footer-01" }) {
            ...Footer01
        }
        contact: general(section: { eq: "contact" }) {
            ...Contact01
        }
        page(title: { eq: "my-account" }) {
            content {
                ...PageContent
            }
        }
    }
`;
FAQPage.propTypes = {
    data: PropTypes.shape({
        header: PropTypes.shape({}),
        navigation: PropTypes.shape({}),
        footer: PropTypes.shape({}),
        contact: PropTypes.shape({}),
        page: PropTypes.shape({
            content: PropTypes.arrayOf(PropTypes.shape({})),
        }),
    }),
};

export default FAQPage;
